<!-- BLOQUE SUPERVISOR -->
<ng-container>
  <div class="chat-list-panel supervisor-panel agent-skin">
    <!-- Supervisor Header con métricas KPI -->
    <div class="panel-header">
      <div class="header-top">
        <h3 class="panel-title">{{ panelTitle }}</h3>
        @if (!isSupervisor) {
          <button
            type="button"
            pButton pRipple
            icon="pi pi-history"
            (click)="openHistory()"
          ></button>
        }

      </div>
      <div class="search-container search-container--enhanced">
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input
            type="text"
            pInputText
            [(ngModel)]="searchQuery"
            (input)="filterConversations()"
            [placeholder]="'agent.list.searchPlaceholder' | translate"
            [attr.aria-label]="'agent.list.searchAriaLabel' | translate"
          />
        </span>
      </div>
    </div>

    <div class="supervisor-header">

      <div class="kpi-cards">
        <div class="kpi-card">
          <div class="kpi-label">{{ 'agent.list.kpiTotalChats' | translate }}</div>
          <div class="kpi-value">{{ pendingConversations.length + activeConversations.length }}</div>
        </div>
        <div class="kpi-card">
          <div class="kpi-label">{{ 'agent.list.kpiUnassigned' | translate }}</div>
          <div class="kpi-value">{{ pendingConversations.length }}</div>
        </div>
        <div class="kpi-card">
          <div class="kpi-label">{{ 'agent.list.kpiAssigned' | translate }}</div>
          <div class="kpi-value">{{ activeConversations.length }}</div>
        </div>
      </div>
    </div>

    <!-- NAV DE TABS NATIVAS -->
    <nav class="native-tabs">
      <button
        class="tab-btn"
        [class.active]="activeTab === 'available'"
        (click)="activeTab = 'available'"
      >
        {{ 'agent.list.tabUnassigned' | translate }} ({{ pendingConversations.length }})
      </button>
      <button
        class="tab-btn"
        [class.active]="activeTab === 'assigned'"
        (click)="activeTab = 'assigned'"
      >
        {{ 'agent.list.tabAssigned' | translate }} ({{ activeConversations.length }})
      </button>
    </nav>

    <!-- CONTENIDO TAB “DISPONIBLES” -->
    <section class="tab-content" *ngIf="activeTab === 'available'">
      <div class="chat-list">
        <div
          *ngFor="let chat of pendingConversations; trackBy: trackByConversationId"
          class="chat-item"
          (click)="onChatSelect(chat)"
          [ngClass]="{
            unread: chat.status === status_available.Pending,
            selected: selectedConversation?.conversationId === chat.conversationId
          }"
          [pTooltip]="chat.clientId || ('agent.list.unknownClient' | translate)"
          tooltipPosition="right"
        >
          <div class="chat-avatar">
            {{ getInitials(getDisplayName(chat) || '') }}
            <p-badge
              *ngIf="hasNewMessage(chat.conversationId!) && selectedConversation?.conversationId !== chat.conversationId"
              severity="danger"
              [ngStyle]="{ position: 'absolute', top: '-4px', right: '-4px' }"
              value=""
            ></p-badge>
          </div>
          <div class="chat-info">
            <ng-container *ngIf="getDisplayName(chat) || getCustomDetails(chat); else fallbackInactive">
              <span class="client-id">{{ getDisplayName(chat) }}</span>
              <small class="custom-info">{{ getCustomDetails(chat) }}</small>
              <small class="custom-info campaign">{{ getCampaignWithTransfer(chat) }}
                <span *ngIf="isSupervisor && !chat.agentId" class="not-assigned-indicator"></span>
              </small>
            </ng-container>
            <ng-template #fallbackInactive>
              <div class="client-id-fallback">{{ chat.clientId || ('agent.list.unknownClient' | translate) }}</div>
            </ng-template>
            <span class="timestamp">{{ chat.startDate | date:'d/M/Y hh:mm a':'UTC' }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- CONTENIDO TAB “ASIGNADOS” -->
    <section class="tab-content" *ngIf="activeTab === 'assigned'">
      <div class="chat-list">
        <div
          *ngFor="let chat of activeConversations; trackBy: trackByConversationId"
          class="chat-item"
          (click)="onChatSelect(chat)"
          [ngClass]="{
            unread: chat.status === status_available.Pending,
            selected: selectedConversation?.conversationId === chat.conversationId
          }"
          [pTooltip]="chat.clientId || ('agent.list.unknownClient' | translate)"
          tooltipPosition="right"
        >
          <div class="chat-avatar">
            {{ getInitials(getDisplayName(chat) || '') }}
            <p-badge
              *ngIf="hasNewMessage(chat.conversationId!) && selectedConversation?.conversationId !== chat.conversationId"
              severity="danger"
              [ngStyle]="{ position: 'absolute', top: '-4px', right: '-4px' }"
              value=""
            ></p-badge>
          </div>
          <div class="chat-info">
            <ng-container *ngIf="getDisplayName(chat) || getCustomDetails(chat); else fallbackAssigned">
              <span class="client-id">{{ getDisplayName(chat) }}</span>
              <small class="custom-info">{{ getCustomDetails(chat) }}</small>
              <small class="custom-info campaign">{{ getCampaignWithTransfer(chat) }}
                <span *ngIf="isSupervisor && chat.agentId" class="assigned-indicator"></span>
              </small>
            </ng-container>
            <ng-template #fallbackAssigned>
              <div class="client-id-fallback">{{ chat.clientId || ('agent.list.unknownClient' | translate) }}</div>
            </ng-template>
            <span class="timestamp">{{ chat.startDate | date:'d/M/Y hh:mm a':'UTC' }}</span>
          </div>
        </div>
      </div>
    </section>
  </div>

  <!-- Modal de Historial -->
  <p-dialog
    [header]="'agent.list.historyTitle' | translate"
    [(visible)]="showHistoryModal"
    modal="true"
    [style]="{ width: '65dvw', maxWidth: '1200px' }"
    styleClass="history-dialog"
  >
    <div class="history-content">
      <!-- Lista Paginada de Conversaciones Finalizadas -->
      <div class="history-list">
        <ng-container *ngIf="loadingHistory; else listContent">
          <p>{{ 'agent.list.loadingHistory' | translate }}</p>
        </ng-container>
        <ng-template #listContent>
          <div
            *ngFor="let conv of finishedConversations"
            class="history-item"
            [class.selected]="conv.conversationId === selectedHistoryConversation?.conversationId"
            (click)="selectHistory(conv)"
          >
            <div class="hist-title">
              {{ getDisplayName(conv) || conv.clientId }}
            </div>
            <div class="hist-date">
              {{ conv.startDate | date:'dd/MM/yy hh:mm a':'UTC' }}
            </div>
          </div>
        </ng-template>
      </div>

      <!-- Área de Transcripción -->
      <div class="history-transcript">
        <h4>{{ 'agent.list.transcript' | translate }}
          <button
            type="button"
            pButton
            [label]="'agent.list.copyTranscript' | translate"
            class="p-button-sm"
            (click)="copyTranscriptToClipboard()"
          ></button>
        </h4>
        <div *ngIf="loadingTranscript" class="loading">
          {{ 'agent.list.loading' | translate }}
        </div>
        <ng-container *ngIf="!loadingTranscript">
          <div *ngIf="selectedHistoryConversation && transcript.length; else noMessages">
            <div
              *ngFor="let msg of transcript"
              class="msg"
              [ngClass]="{ agent: msg.type === 'agent', user: msg.type === 'user' }"
            >
                <span class="msg-time">
                  {{ msg.dateSent | date:'hh:mm a':'UTC' }}
                </span>
              <strong class="msg-who">
                {{
                  msg.type === 'agent'
                    ? ('agent.list.agent' | translate)
                    : (getDisplayName(selectedHistoryConversation) || ('agent.list.client' | translate))
                }}:
              </strong>
              <span>{{ msg.content }}</span>
            </div>
          </div>
          <ng-template #noMessages>
            <div class="no-messages">{{ 'agent.list.noMessages' | translate }}</div>
          </ng-template>
        </ng-container>
      </div>
    </div>

    <p-footer>
      <button
        type="button"
        pButton
        [label]="'agent.list.close' | translate"
        class="p-button-sm"
        (click)="showHistoryModal = false"
      ></button>
    </p-footer>
  </p-dialog>
</ng-container>

